import { BehaviorSubject } from "rxjs/BehaviorSubject";
import Helpers from "../helpers/shared.helper";

var Storage = {};
var obsrv = {};

Storage.get_obsrv = setting => {
	if (Object.keys(obsrv).indexOf(setting) === -1) {
		if (Object.keys(Storage).indexOf(setting) === -1) {
			Storage[setting] = null;
		}
		obsrv[setting] = new BehaviorSubject(Storage[setting]);
	}
	return obsrv[setting].asObservable();
};

Storage.get = (setting, look_in_browser_storage = false) => {
	if (Object.keys(Storage).indexOf(setting) !== -1 && Storage[setting]) {
		return Storage[setting];
	} else {
		if (look_in_browser_storage) {
			let in_storage = window.localStorage.getItem(setting);
			if (in_storage) {
				return in_storage;
			}
		}
		return null;
	}
};

Storage.set = (setting, val, store_in_browser = false) => {
	// Helpers.log("Setting " + setting + " to: ", val);

	// if (Settings.get("debug") === true) {
	// 	// To simulate delivery
	// 	if (setting === "flags") {
	// 		if (Storage.get("mock_delivery", true)) {
	// 			val.IsDeliveryRequested = true
	// 			val.DeliveryInProgress = true
	// 		}
	// 	}
	// }

	Storage[setting] = val;
	if (store_in_browser) {
		window.localStorage.setItem(setting, val);
	}
	if (Object.keys(obsrv).indexOf(setting) === -1) {
		obsrv[setting] = new BehaviorSubject(Storage[setting]);
	}
	obsrv[setting].next(val);
};

Storage.clear = setting => {
	Storage.set(setting, null);
	if (window.localStorage.getItem(setting)) {
		window.localStorage.removeItem(setting);
	}
};

Storage.getOrfetch = (property, serviceFetcher, force_fetch = false) => {

	if (Storage.get("fetching_" + property)) {
		return Storage.get("fetching_" + property);
	}

	if (Storage.get(property) && !force_fetch) {
		Helpers.log("found " + property + " in storage.. ");
		let data = Storage.get(property);
		Storage.set("fetching_" + property, false);
		return new Promise((resolve, reject) => {
			resolve(data);
		});
	} else {
		let f = serviceFetcher();
		Storage.set("fetching_" + property, f);
		Helpers.log("fetching " + property + " from api..");

		f.then(res => {
			Storage.set("fetching_" + property, false);
		}).catch(err => {
			Storage.set("fetching_" + property, false);
		});
		return f;
	}
};

export default Storage;